import React, {useContext} from "react"

// context and data
import data from "../../../../data"
import {ShopContext} from "../../../../context"

// components
import {Button} from "../../../controls"

// styling
import "./Actions.scss"

// the component
function Actions({activity, onClickCustomize, position, displayAsSecondary, hideSecondaryActions}) {
  // context
  const shop = useContext(ShopContext)

  // activty already in cart?
  let adventureActivity = data.Cart.getAdventureActivity(activity._id)
  
  // render
  let content
  if(adventureActivity) {
    const summary = data.Cart.getAdventureActivitySummary(adventureActivity)
    
    const options = summary.options.map(o => {
      return `${o.unitCount} * ${o.title} (${o.price.toFixed(2)})`
    })

    let parts = [
      summary.region,
      summary.participantCount + " Teilnehmer"
    ]
    if(options.length > 0) {
      parts.push(options.join(', '))
    }

    let info = null
    if(position === "sidebar") {
      info = `diese Aktivität befindet sich im Warenkorb: ${parts.join(', ')} = ${summary.price.toFixed(2)}`
    }
    else {
      info = `im Warenkorb: ${parts.join(', ')} = ${summary.price.toFixed(2)}`
    }

    content = (
      <div className="c-activity-actions">
        <div className="text">
          {info}
        </div>
        <div className="buttons">
          <Button 
            label="entfernen"
            kind="remove" 
            onClick={() => {shop.cart.removeActivity(activity._id)}}
          />
          <Button 
            label="anpassen" 
            onClick={onClickCustomize}
          />
        </div>
      </div>
    )
    if(hideSecondaryActions) {
      content = null;
    }
  }
  else {
    content = (
      <>
        <Button 
          label="wählen" 
          onClick={onClickCustomize}
          wide={true}
          kind={displayAsSecondary ? "ok-secondary" : "ok"}
        />
      </>
    )
  }

  return (
    <div className="c-activity-actions">
      {content}
    </div>
  )
}

export default Actions